import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import EventForm from "../../../components/events/eventForm";
import { isEmptyObject } from "../../../helpers/functions";
import { saveEventWithPoster } from "../../../helpers/saveEventWithPoster";
import { Storage } from "aws-amplify";

const EventBasicData = ({ id, ...props }) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (!isEmptyObject(props.selectedEvent) && props.selectedEvent.id !== id) {
            props.history.replace(`/events/${id || props.selectedEvent.id}/basic`);
        }
    }, [props.selectedEvent, id, props.history]);

    const dispatchCreateOrUpdate = async (isCreation, name, code, dateFrom, dateTo, eventType, image, active, hasCustomPosterImage) => {
        const result = await saveEventWithPoster({
            data: { name, code, dateFrom, dateTo, eventType, active, hasCustomPosterImage },
            previous: isCreation ? null : props.selectedEvent,
            image,
            create: props.createEvent,
            update: props.updateEvent,
            upload: (eventId, posterName, file) => Storage.put(`${eventId}/Configuration/${posterName}`, file, { contentType: file.type }),
        });
        if (result.imageWarning || result.event?.publicPosterWarning) toast.warning(t('publicGallery.posterWarning'));
        props.history.replace(`/events/${result.event.id}/basic`);
        return result.event;
    };
    const dispatchCancel = () => {
        props.deselectEvent();
        props.history.replace('/events');
    };
    const dispatchDelete = () => {
        props.deleteEvent(id);
        props.deselectEvent();
        props.history.replace('/events');
    };
    return <EventForm event={props.selectedEvent} dispatchCreateOrUpdate={dispatchCreateOrUpdate}
        dispatchCancel={dispatchCancel} dispatchDelete={dispatchDelete} loading={props.loading} />;
};
export default withRouter(EventBasicData);
